
import { useExerciseStore } from "../../stores/exercisesStore";
import { useFilterConfigStore } from "../../stores/filterConfig";
import { useNewSubjectStore } from "../../stores/newSubjectStore";
import { Icon } from "../../../../core/components/atoms/Icon";

interface IFilterTagsList {
  origin?: string;
}

const FilterTagsList: React.FC<IFilterTagsList> = ({ origin = 'modal' }) => {

  const { 
    type, 
    setType,
    status, 
    setStatus,
    favorites,
    setFavorites
  } = useFilterConfigStore();

  const { 
    favorite,
    setFavorite,
    unanswered,
    setUnanswered,
    rightAnswer,
    setRightAnswer,
    wrongAnswer,
    setWrongAnswer,
    difficulty,
    setDifficulty,
    questionOptions,
    setQuestionOptions,
    isEnem,
    setIsEnem
  } = useExerciseStore();

  const { selectedSubjects, setSelectedSubjects, selectOptions } = useNewSubjectStore()

  const removeSubject = (slug: string) => {
    const auxArray = [...selectedSubjects];
    const newArray = auxArray.filter((it) => it !== slug);

    setSelectedSubjects(newArray);
  }

  const removeDificulty = (slug: string) => {
    const auxArray = [...difficulty];
    const newArray = auxArray.filter((it) => it !== slug);

    setDifficulty(newArray);
  }

  const removeType = (slug: string) => {
    const auxArray = [...isEnem];
    const newArray = auxArray.filter((it) => it !== slug);

    setIsEnem(newArray);
  }

  const removeQuestionOption = (slug: string) => {
    const auxArray = [...questionOptions];
    const newArray = auxArray.filter((it) => it !== slug);

    setQuestionOptions(newArray);
  }

  const FilterChip = ({ label, onRemove, hasRemove }: { label: string, onRemove: () => void; hasRemove?: boolean; }) => (
    <div className="flex flex-row gap-sm items-center bg-mono-color-lighter text-mono-color-black border-hairline border-mono-color-lighter text-sm px-2 py-1 rounded-sm">
      {!hasRemove && <Icon Icon="close" type="material" onClick={() => onRemove()} className="cursor-pointer text-sm" />}
      {label}
    </div>
  )

  const statusOptions = (status: string) => {
    switch(status) {
      case 'played':
        return 'Reproduzidos'
      case 'not_played':
        return 'Não reproduzidos'
      case 'seen':
        return 'Visualizados'
      case 'not_seen':
        return 'Não visualizados'
      case 'listened':
        return 'Reproduzidos'
      case 'not_listened':
        return 'Não reproduzidos'
      default:
        return ''
    }
  }

  const difficultiesOptions = (difficulty: string) => {
    switch(difficulty) {
      case 'easy':
        return 'Fácil'
      case 'medium':
        return 'Médio'
      case 'hard':
        return 'Difícil'
      case 'random':
        return 'Aleatórios'
      default: 
        return ''
    }
  }

  const questionOptionsNames = (option: string) => {
    switch(option) {
      case 'single_answer':
        return 'Resposta única'
      case 'multiple_answer':
        return 'Resposta somatória'
      case 'discursive':
        return 'Resposta discursiva'
      default: 
        return '-'
    }
  }

  const exerciseTypeNames = (option: string) => {
    switch(option) {
      case 'enem':
        return 'Enem'
      case 'vestibulares':
        return 'Vestibulares'
      default: 
        return '-'
    }
  }

  return (
    <div id="subjects-scroll" className='flex flex-row gap-md overflow-x-auto h-fit'>
      {selectedSubjects.map((it, i) => 
        <FilterChip 
          key={i} 
          label={selectOptions.find((item) => item.value === it)?.label ?? ''}
          onRemove={() => removeSubject(it)}
        />
      )}
      {type.length > 0 && type.map((it, i) => 
        <FilterChip  
          key={i}
          label={it === 'main' ? 'Principal' : 'Resumo'}
          onRemove={() => setType(it)}
          hasRemove={origin === 'main'}
        />
      )}
      {status.length > 0 && status.map((it, i) => 
        <FilterChip 
          key={i}
          label={statusOptions(it)}
          onRemove={() => setStatus(it)}
          hasRemove={origin === 'main'}
        />
      )}
      {favorites && <FilterChip label="Favoritos" onRemove={() => setFavorites(!favorites)} hasRemove={origin === 'main'} />}
      {favorite && <FilterChip label="Favoritos" onRemove={() => setFavorite(!favorite)} hasRemove={origin === 'main'} />}
      {unanswered && <FilterChip label="Não respondidos" onRemove={() => setUnanswered(!unanswered)} hasRemove={origin === 'main'} />}
      {rightAnswer && <FilterChip label="Respostas certas" onRemove={() => setRightAnswer(!rightAnswer)} hasRemove={origin === 'main'} />}
      {wrongAnswer && <FilterChip label="Respostas erradas" onRemove={() => setWrongAnswer(!wrongAnswer)} hasRemove={origin === 'main'} />}
      {difficulty.length > 0 && difficulty.map((it, i) => 
        <FilterChip key={i} label={difficultiesOptions(it)} onRemove={() => removeDificulty(it)} hasRemove={origin === 'main'} />
      )}
      {isEnem.length > 0 && isEnem.map((it, i) => 
        <FilterChip key={i} label={exerciseTypeNames(it)} onRemove={() => removeType(it)} hasRemove={origin === 'main'} />
      )}
      {questionOptions.length > 0 && questionOptions.map((it, i) => 
        <FilterChip key={i} label={questionOptionsNames(it)} onRemove={() => removeQuestionOption(it)} hasRemove={origin === 'main'} />
      )}
    </div>
  )
}

export default FilterTagsList;